<template>
  <div id="toggle-icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12.828"
      height="7.435"
      viewBox="0 0 12.828 7.435"
    >
      <path
        id="Path"
        d="M0,0,5,5.021,10,0"
        transform="translate(11.414 6.021) rotate(180)"
        fill="none"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        stroke-width="2"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "ToggleIcon",
  props: {
    color: {
      type: String,
      default: "#606060"
    }
  },
  components: {},
  data: () => ({}),
  created() {},
  computed: {},
  methods: {}
};
</script>
<style lang="scss" scoped>
#toggle-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
